export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-snapchat-96585548e10d903f36f584e46165c567.svg";